export const parseVersion = (version: string, technology: string): string => {
  if (technology === 'nuget') return version
  return version.split('.').slice(0, 3).join('.')
}
